import axios from "axios";
import localStorageKeys from "../constants/localStorageKeys";

const apiCall = axios.create({
	baseURL: window.location.origin + "/api",
});
apiCall.interceptors.request.use((req) => {
	if (localStorage.getItem(localStorageKeys.USER_DATA)) {
		const userData = JSON.parse(
			localStorage.getItem(localStorageKeys.USER_DATA)
		);
		req.headers.Authorization = `Bearer ${userData.token}`;
	}
	return req;
});

export default apiCall;
